import { createContext, useState, useContext, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

const MentiSessionContext = createContext();

export function MentiSessionProvider({ children, sessionId }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }

    const sessionRef = doc(db, 'mentiSessions', sessionId);
    const unsubscribe = onSnapshot(
      sessionRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setSession({ id: snapshot.id, ...snapshot.data() });
          setError(null);
        } else {
          setError('Fann ikkje Menti-økta');
        }
        setLoading(false);
      },
      (err) => {
        console.error('Menti session listener error:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [sessionId]);

  return (
    <MentiSessionContext.Provider value={{ session, loading, error }}>
      {children}
    </MentiSessionContext.Provider>
  );
}

export function useMentiSession() {
  const context = useContext(MentiSessionContext);
  if (!context) {
    throw new Error('useMentiSession must be used within MentiSessionProvider');
  }
  return context;
}
